<ng-container *ngIf="currency && currency.symbol; else noCurrency">
  <span>{{value | currency:currency?.symbol:'symbol': undefined: locale}}</span>
</ng-container>
<ng-template #noCurrency>
  <span>{{value | currency:currencyId:'code': undefined: locale}}</span>
</ng-template>
